exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".multiselect__placeholder{padding-top:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5cc9f1c8!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/DynamicPricingRuleComponent.vue
// module id = 894
// module chunks = 2